import { LegacyHttpRequest as HttpOptions, LegacyHttpResponse as HttpResponse } from 'src/legacy/http'
import router from 'src/router'
import store from 'src/store'
import { FiltradorDeErros } from 'src/erros'
import { ERRO_PAGAMENTO_EXPIRADO } from '../utils'

let estaDeslogando = false
const rotaDeLogin = '/cognito/login'
const enviarParaRotaDeLogin = true

type Resposta = (response: HttpResponse) => void
type FuncaoDeResposta = (response: Resposta) => void

/**
 * Função que desloga o usuário quando o token de autenticação expirar
 * O usuário é deslogado caso: aconteça algum retorno 401 da API e ele não esteja na rota de login ou já não esteja sendo deslogado
 * @param {HttpOptions} _ - Opções da requisição (não utilizado)
 * @param {FuncaoDeResposta} obterResposta - Função que recebe a resposta da requisição
 * @returns {void}
 */
const deslogarQuandoTokenExpirar = (_: HttpOptions, obterResposta: FuncaoDeResposta): void => {
  try {
    obterResposta((response: HttpResponse): void => {
      const { status } = response
      const tokenExpirou = status === 401
      const pagamentoExpirado = response.body === ERRO_PAGAMENTO_EXPIRADO
      const rotaAtual = router.currentRoute.value.path
      const estaNaRotaDeLogin = rotaAtual === rotaDeLogin

      // pagamento expirado não pode seguir esse fluxo, pois é tratado no erro de /short 
      if (tokenExpirou && !pagamentoExpirado && !estaNaRotaDeLogin && !estaDeslogando) {
        estaDeslogando = true
        store.dispatch('logout', enviarParaRotaDeLogin).then(() => {
          estaDeslogando = false
        })
      }
    })
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro as unknown as Error)
  }
}

export default deslogarQuandoTokenExpirar
